


































































import {Component, Vue, Watch} from 'vue-property-decorator';
import _ from 'lodash'
import * as emailRecord from "@/store/EmailRecord/EmailRecord";
import * as auth from "@/store/authenticate";
import {EmailRecord} from "../store/EmailRecord";
@Component({
    components: {


    },
    name: 'MessageSearch',
})
export default class MessageSearch extends Vue{
    emailData: EmailRecord[] = []
    typeOfSearch: string = 'EmailContent'
    emailSearchText: string = ''
    debouncedGetAnswer = _.debounce(async (value) => {
        await this.searchForEmails(value)
    }, 1000)
    @Watch('emailSearchText')
    async onEmailSearchTextChanged(value: string, oldValue: string) {
        await this.debouncedGetAnswer(value)
    }
    @Watch('dropDownSearchValue')
    onDropDownChanged(value: string, oldValue: string) {
        this.emailSearchText = ''
        switch (value) {
            case "Content":
                this.typeOfSearch = 'EmailContent'
                break;
            case "Matter Number":
                this.typeOfSearch = 'Matter'
                break;
            case "Contact Name":
                this.typeOfSearch ='Contact'
                break;
            case "Email Address":
                this.typeOfSearch = 'EmailAddress'
                break;
            default:
                this.typeOfSearch = 'EmailContent'
        }
    }
    async searchForEmails(value:string){

        await this.emailRecords(value);

    }
    async emailRecords(searchText: string){
        try {
            let resultSearchString = searchText;
            if(!resultSearchString){
                return;
            }

            const contentHeader =  {
                'Accept': 'application/json',
            };
            resultSearchString = resultSearchString.trim().toLowerCase();
            const requestUrl = "/document/email?TypeOfSearch=" + this.typeOfSearch +"&SearchText=" + resultSearchString;
            let response = await this.axios.get("https://api.messagehub.ca" + requestUrl, {
                headers: contentHeader,
                withCredentials: true
            })
            this.emailData = <Array<EmailRecord>> response.data.records;
            emailRecord.updateSearchResult(this.$store, <Array<EmailRecord>> response.data.records)
           // this.$store.dispatch('emailrecord/UPDATE_SEARCH_RESULT', tokenData);
           // this.records = tokenData;
        }
        catch (e) {
            console.log(e.message);
        }
    }
    parseDate (jsonDateString: string): string{
        return new Date(parseInt(jsonDateString.replace('/Date(', ''))).toLocaleDateString()
    }
    truncateText (str: string, length:number, ending: string): string {
        if (length == null) {
            length = 100;
        }
        if (ending == null) {
            ending = '...';
        }
        if (str.length > length) {
            return str.substring(0, length - ending.length) + ending;
        } else {
            return str;
        }
    }
    async created() {
        let existingEmails: EmailRecord[] = emailRecord.getSearchResult(this.$store);
        if (existingEmails == undefined){
            this.emailData = []
        }else{
            this.emailData = existingEmails;
        }

    }
    data () {
        return {
            emailSearchText: '',
            dropDownSearchValue: '',
            emailData: [],
            categories: [
                "Content",
                "Matter Number",
                "Contact Name",
                "Email Address"
            ],
            headers: [
                {
                    text: 'Subject',
                    align: 'left',
                    sortable: true,
                    value: 'subject',
                    width: '35%'
                },
                { text: 'Client', value: 'clientName' },
                { text: 'Matter', value: 'matterName' },
                { text: 'Date', value: 'dateSentOrReceived' },
                { text: 'From', value: 'from.name' },
            ],
        }
    }

}
